import cn from 'classnames';
import { TMaxPlayers } from '@api/types/blackjack';
import { IRoomTableItem, ROOM } from '@consts/blackjack';
import { BREAKPOINTS } from '@consts/ui';
import { IModule } from '@api/types/general';
import { getUserIdFromToken } from '@utils/utils';
import BlackjackPlayer from './player';
import FairnessBadge from '../components/fairness-badge';
import FAKE_DATA from './PlayersData';
import useReduxState from '@hooks/useReduxState';
import styles from './table.module.scss';

const MAX_PLAYERS: number = 7;

const Table = ({ className = '' }: IModule): JSX.Element => {
  const [windowWidth] = useReduxState((state) => state.ui.windowWidth);
  const Table: IRoomTableItem = ROOM.TABLES[MAX_PLAYERS as TMaxPlayers];
  const currentPlayerId: string = getUserIdFromToken();

  const otherPlayers = FAKE_DATA.filter(
    (player) => player.user.id !== currentPlayerId
  );
  const player = FAKE_DATA.find(
    (player) => player.user.id === currentPlayerId
  )!;

  /* Components */

  const Players: JSX.Element[] = otherPlayers.map((player, idx) => (
    <BlackjackPlayer
      {...{ player, playerNumber: idx + 1 }}
      key={player.user.id || idx}
    >
      <BlackjackPlayer.User />
      <BlackjackPlayer.Cards />
      <BlackjackPlayer.Actions />
    </BlackjackPlayer>
  ));

  const PlayersPlaceholders: JSX.Element[] = [
    ...new Array(MAX_PLAYERS - FAKE_DATA.length),
  ].map((_, idx) => (
    <BlackjackPlayer
      key={player.user.id || idx}
      {...{ playerNumber: FAKE_DATA.length + idx }}
    >
      <BlackjackPlayer.User />
      <BlackjackPlayer.Cards />
      <BlackjackPlayer.Actions />
    </BlackjackPlayer>
  ));

  const MainPlayer: JSX.Element = (
    <BlackjackPlayer {...{ player, playerNumber: 0 }}>
      <BlackjackPlayer.User />
      <BlackjackPlayer.Cards />
      <BlackjackPlayer.Actions />
    </BlackjackPlayer>
  );

  const MobileLayout: JSX.Element = (
    <div className={styles.table}>
      <section className={styles.table__playersList}>{Players}</section>
      <section className={styles.main}>
        {/* {MainPlayer} */}
        <div className={styles.main__tableWrapper}>{Table.cropped}</div>
      </section>
    </div>
  );

  const DesktopLayout: JSX.Element = (
    <div className={styles.table}>
      <FairnessBadge
        text="Fair Game Checker"
        className={styles.table__fairness}
      />

      <div className={styles.main}>
        {Table.full}
        {MainPlayer}
        {Players}
        {PlayersPlaceholders}
      </div>
    </div>
  );

  return (
    <section className={cn(styles.game, className)}>
      {windowWidth < BREAKPOINTS.LG ? MobileLayout : DesktopLayout}
    </section>
  );
};

export default Table;
